import React, { useState } from "react";
import { Drawer, Grid } from "antd";
import styles from "./side-bar.module.scss";
import CopilotIcon from "@assets/componentIcons/CopilotIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { navigationItems } from "@components/layout/superadmin-layout/sideBar/constans";

const { useBreakpoint } = Grid;

const SidebarDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const screens = useBreakpoint();

  const [activeHoverElementId, setActiveHoverElementId] = useState("");

  // Dynamically detect active link
  const getActiveLinkId = (() => {
    const activeIndex = navigationItems.findIndex((item) =>
      pathname.includes(item.navigation),
    );
    return activeIndex !== -1 ? `${activeIndex}` : "0";
  })();

  const SidebarContent = (
    <div className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <div className={styles.headerText}>
          <h2 className={styles.panelTitle}>Master Admin Panel</h2>
        </div>
      </div>
      <ul className={styles.sidebarNavigation}>
        {navigationItems?.map((el, i) => {
          const isActive = getActiveLinkId === `${i}`;
          const isHovered = activeHoverElementId === `${i}`;
          const isHighlighted = isActive || isHovered;

          return (
            <li
              className={styles.sidebarNavigationItem}
              style={{
                backgroundColor: isHighlighted ? "#F7F7F7" : "transparent",
                cursor: "pointer",
                height: 35,
              }}
              key={i}
              id={`${i}`}
              onMouseEnter={() => setActiveHoverElementId(`${i}`)}
              onMouseLeave={() => setActiveHoverElementId("")}
              onClick={() => {
                navigate(el.navigation);
                if (!screens.lg) {
                  setTimeout(() => {
                    onClose();
                  }, 50);
                }
              }}
            >
              <el.icon color={isHighlighted ? "#2E2E2E" : "black"} />
              <p
                style={{
                  color: isHighlighted ? "#2E2E2E" : "black",
                  fontWeight: isHighlighted ? "bold" : "200",
                }}
              >
                {el.name}
              </p>
            </li>
          );
        })}
      </ul>

      <div
        className={styles.sidebarNavigationItem}
        style={{ alignItems: "flex-start" }}
        onMouseEnter={() => setActiveHoverElementId(`link`)}
        onMouseLeave={() => setActiveHoverElementId("")}
      ></div>
    </div>
  );

  if (screens.lg) {
    return (
      <div
        style={{
          width: 250,
          height: "100vh",
          position: "fixed",
          top: 0,
          left: 0,
          background: "#fff",
          borderRight: "1px solid #f0f0f0",
          zIndex: 100,
        }}
      >
        {SidebarContent}
      </div>
    );
  }

  return (
    <Drawer
      title={null}
      placement="left"
      closable={false}
      onClose={onClose}
      open={open}
      width={250}
      bodyStyle={{ padding: 0 }}
    >
      {SidebarContent}
    </Drawer>
  );
};

export default SidebarDrawer;
